/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Pipelines_team$ref = any;
export type Pipelines_QueryVariables = {|
  team: string
|};
export type Pipelines_QueryResponse = {|
  +team: ?{|
    +$fragmentRefs: Pipelines_team$ref
  |}
|};
export type Pipelines_Query = {|
  variables: Pipelines_QueryVariables,
  response: Pipelines_QueryResponse,
|};
*/


/*
query Pipelines_Query(
  $team: ID!
) {
  team(slug: $team) {
    ...Pipelines_team
    id
  }
}

fragment PipelinesChooser_team on Team {
  id
  slug
  organization {
    pipelines(search: "", first: 10, order: RELEVANCE) {
      edges {
        node {
          id
          name
          repository {
            url
          }
        }
      }
    }
    id
  }
  permissions {
    teamPipelineCreate {
      allowed
    }
  }
}

fragment Pipelines_team on Team {
  ...PipelinesChooser_team
  pipelines(first: 10, order: NAME) {
    ...ShowMoreFooter_connection
    count
    edges {
      node {
        id
        accessLevel
        pipeline {
          id
          name
          url
          repository {
            url
          }
        }
        permissions {
          teamPipelineUpdate {
            allowed
          }
          teamPipelineDelete {
            allowed
          }
        }
      }
    }
  }
}

fragment ShowMoreFooter_connection on Connection {
  __isConnection: __typename
  pageInfo {
    hasNextPage
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "team"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "team"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "allowed",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Pipelines_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Pipelines_team"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Pipelines_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v3/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "order",
                    "value": "RELEVANCE"
                  },
                  {
                    "kind": "Literal",
                    "name": "search",
                    "value": ""
                  }
                ],
                "concreteType": "PipelineConnection",
                "kind": "LinkedField",
                "name": "pipelines",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PipelineEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Pipeline",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "pipelines(first:10,order:\"RELEVANCE\",search:\"\")"
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamPermissions",
            "kind": "LinkedField",
            "name": "permissions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Permission",
                "kind": "LinkedField",
                "name": "teamPipelineCreate",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v3/*: any*/),
              {
                "kind": "Literal",
                "name": "order",
                "value": "NAME"
              }
            ],
            "concreteType": "TeamPipelineConnection",
            "kind": "LinkedField",
            "name": "pipelines",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamPipelineEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamPipeline",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accessLevel",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Pipeline",
                        "kind": "LinkedField",
                        "name": "pipeline",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamPipelinePermissions",
                        "kind": "LinkedField",
                        "name": "permissions",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Permission",
                            "kind": "LinkedField",
                            "name": "teamPipelineUpdate",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Permission",
                            "kind": "LinkedField",
                            "name": "teamPipelineDelete",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Connection",
                "abstractKey": "__isConnection"
              }
            ],
            "storageKey": "pipelines(first:10,order:\"NAME\")"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0cbf59dde19e92ca8d7459aea2c65c98",
    "id": null,
    "metadata": {},
    "name": "Pipelines_Query",
    "operationKind": "query",
    "text": "query Pipelines_Query(\n  $team: ID!\n) {\n  team(slug: $team) {\n    ...Pipelines_team\n    id\n  }\n}\n\nfragment PipelinesChooser_team on Team {\n  id\n  slug\n  organization {\n    pipelines(search: \"\", first: 10, order: RELEVANCE) {\n      edges {\n        node {\n          id\n          name\n          repository {\n            url\n          }\n        }\n      }\n    }\n    id\n  }\n  permissions {\n    teamPipelineCreate {\n      allowed\n    }\n  }\n}\n\nfragment Pipelines_team on Team {\n  ...PipelinesChooser_team\n  pipelines(first: 10, order: NAME) {\n    ...ShowMoreFooter_connection\n    count\n    edges {\n      node {\n        id\n        accessLevel\n        pipeline {\n          id\n          name\n          url\n          repository {\n            url\n          }\n        }\n        permissions {\n          teamPipelineUpdate {\n            allowed\n          }\n          teamPipelineDelete {\n            allowed\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ShowMoreFooter_connection on Connection {\n  __isConnection: __typename\n  pageInfo {\n    hasNextPage\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c415e98b7a35a39cadd0c37bf9172fef';

module.exports = node;
